import { render, staticRenderFns } from "./aviso.vue?vue&type=template&id=189311aa&scoped=true"
import script from "./aviso.vue?vue&type=script&lang=js"
export * from "./aviso.vue?vue&type=script&lang=js"
import style0 from "./aviso.vue?vue&type=style&index=0&id=189311aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189311aa",
  null
  
)

export default component.exports